import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
// import { HttpModule } from '@angular/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {ToastrModule} from 'ngx-toastr';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {OwlModule} from 'angular-owl-carousel';
// NGRX
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import {StoreRouterConnectingModule} from '@ngrx/router-store';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';

import {AppRoutingModule} from './app-routing.module';
import {SharedModule} from './shared/shared.module';
import {ElementsModule} from './pages/elements/elements.module';
import {PagesModule} from './pages/others/pages.module';
import {HomeModule} from './pages/home/home.module';
// reducers
import {appReducers, metaReducers} from './core/reducers/app.reducer';
import {wishlistReducer} from './core/reducers/wishlist.reducer';
import {cartReducer} from './core/reducers/cart.reducer';

import {AppComponent} from './app.component';
import {LayoutComponent} from './shared/layout/layout.component';
import {LightboxModule} from 'ngx-lightbox';
import {JwtInterceptor} from './shared/interceptors/jwt.interceptor';
import {SEOService} from './shared/services/seo.service';
import {SearchService} from './shared/services/search.service';
import {EditorialModule} from './pages/editorial/editorial.module';
import {VideoModule} from './pages/video/video.module';
import {AboutModule} from './pages/about/about.module';
import {ContactModule} from './pages/contact/contact.module';
import {PlanModule} from './pages/plan/plan.module';
import {AppInterceptor} from './shared/interceptors/app-interceptor';
import {PreloaderComponent} from './shared/components/preloader/preloader.component';
import {TagInputModule} from 'ngx-chips';
import {WishlistModule} from './pages/wishlist/wishlist.module';
import {NgxBootstrapMultiselectModule} from 'ngx-bootstrap-multiselect';
import {SuccessModule} from './pages/success/success.module';
import {AiModule} from './pages/ai/ai.module';
import {AiEnquiryModule} from './pages/ai-enquiry/ai-enquiry.module';
import {SpellCheckerModule} from 'ngx-spellchecker';
import { LicenseRequestVerificationComponent } from './pages/ai/license-request-verification/license-request-verification.component';
import { AuthCallbackComponent } from './pages/others/auth-callback/auth-callback.component';
import { HomeComponent } from './pages/exclusive/home/home.component';
import { AiChatComponent } from './pages/ai-chat/ai-chat.component';
import { PricingDialogComponent } from './pages/ai-chat/pricing-dialog/pricing-dialog.component';
import { EnterpriseComponent } from './pages/enterprise/enterprise.component';
@NgModule({
    declarations: [
        AppComponent,
        LayoutComponent,
        PreloaderComponent,
        LicenseRequestVerificationComponent,
        AuthCallbackComponent,
        HomeComponent,
        AiChatComponent,
        PricingDialogComponent,
        EnterpriseComponent,

    ],
    imports: [
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        NgbModule,
        HttpClientModule,
        OwlModule,
        ElementsModule,
        PagesModule,
        SharedModule,
        HomeModule,
        EditorialModule,
        AiEnquiryModule,
        AiModule,
        VideoModule,
        AboutModule,
        ContactModule,
        PlanModule,
        WishlistModule,
        SuccessModule,
        // HttpModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot({
            timeOut: 2000,
            progressBar: true,
            enableHtml: true,
            positionClass: 'toast-top-center'
        }),
        StoreModule.forRoot(appReducers, {metaReducers}),
        StoreModule.forFeature('cart', cartReducer),
        StoreModule.forFeature('wishlist', wishlistReducer),
        // StoreModule.forFeature('compare', compareReducer),
        EffectsModule.forRoot([]),
        StoreRouterConnectingModule.forRoot({stateKey: 'router'}),
        StoreDevtoolsModule.instrument(),
        LightboxModule,
        TagInputModule,
        NgxBootstrapMultiselectModule,
      SpellCheckerModule.forRoot()
    ],

    providers: [
        SearchService,
        SEOService,
        {provide: HTTP_INTERCEPTORS, useClass: AppInterceptor, multi: true},
        {provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true},
    ],
    bootstrap: [AppComponent]
})

export class AppModule {
}
